// extracted by mini-css-extract-plugin
module.exports = {"cardForm":"PaymentMethods_cardForm__1bWY3","cardFormWrapper":"PaymentMethods_cardFormWrapper__2opwG","paymentFooter":"PaymentMethods_paymentFooter__1YH44"};